export { default } from './Dot'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Dots/Dot/index.js